<template>
  <div
    :class="[{ completed: step.isDone, completed_last: isLatestCompletedStep }, 'step']"
  >
    <div class="step-timeline">
      <div class="step-circle">
        <i v-if="index === totalStepCount - 1 || index === 0" class="material-icons">
          home
        </i>
        <span v-else>
          <i v-if="step.isDone" class="material-icons">done</i>
          <span v-if="!step.isDone">{{ index + 1 }}</span>
        </span>
      </div>
    </div>
    <div class="step-content" v-if="step">
      <h3 class="step-name">{{ step.name }}</h3>
      <div class="step-time">
        <span v-if="step.actualTime">{{ step.actualTime | calendar }}</span>
        <span v-else-if="step.estimatedTime">
          EST: {{ step.estimatedTime | calendar }}
        </span>
        <span v-else-if="step.scheduledTime">
          SCHD: {{ step.scheduledTime | calendar }}
        </span>
      </div>
      <div class="step-done-time" v-if="step.isDone">{{ step.delayHuman }}</div>
      <div class="step-done-time" v-else v-bind:class="step.delayLabel">
        {{ step.delayHuman }}
      </div>
    </div>
  </div>
</template>

<script>
import baseController from '../../controllers/base'

export default {
  extends: baseController,
  props: ['step', 'stepId', 'latestCompletedStep', 'totalStepCount', 'index'],
  computed: {
    isLatestCompletedStep() {
      return this.stepId === (this.latestCompletedStep && this.latestCompletedStep.id)
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>
